// @ts-nocheck
export const EMAIL_TYPES = {
  NECESSARY: "NECESSARY",
  OPTIONAL: "OPTIONAL",
};

export const clientNecessaryEmailPreference = {
  isEventSubmission: "Event Submission",
  isNewEventAdded: "New Event Added",
  isEstimateReceived: "Estimate Received",
  isEstimateApproved: "Estimate Approved",
  isInvoiceReceived: "Invoice Received",
};

export const clientOptionalEmailPreference = {
  isEventDetailsUpdated: "Event Details Updates",
  isWorkHoursUpdated: "Work Hours Updates",
  isPositionChanges: "Position Changes",
  isSessionsChanges: "Session Changes",
  isNewNoteAdded: "New Note Added",
  passwordUpdated: "Password Update",
  // 28/09/2026: Show Media emails (wrap-up + reminders). OFF by default.
  showMedia: "Show Media",
};

export const contractorEmailNotificationNecessaryPreference = {
  // gustoApproved: "Gusto Approval",
  opportunities: "Opportunities",
  sowGenerated: "SOW Generation",
  poGenerated: "PO Generation",
  poAutoAccept: "PO Approval",
};

export const contractorEmailNotificationOptionalPreference = {
  profileApproval: "Profile Approval",
  newPositionAssigned: "Position Assigned",
  isPositionChanges: "Position Changes",
  isWorkHoursUpdated: "Work Hours Update",
  isNewNoteAdded: "New Note Added",
  reimbursements: "Reimbursement",
  preBooking: "Pre Booking",
  gustoApprovalRemainders: "Gusto Approval Reminder",
  issueReported: "Reported Issue",
  passwordUpdated: "Password Update",
  // 04/08: o aviso de "PO pago" existia desde o legado e só o ADMIN podia
  // ligar/desligar — quem recebe o pagamento não tinha escolha nenhuma.
  // ⚠️ Vem LIGADO por padrão (`triggerEmailOnPOPaid: true` nos defaults do
  // backend) e, nas contas antigas, o campo está AUSENTE — que o envio também
  // trata como ligado. Desmarcar aqui grava `false` e aí sim o e-mail para.
  triggerEmailOnPOPaid: "PO Paid",
};

export const coordinatorEmailNotificationNecessaryPreference = {
  isNewEventAdded: "New Event Assigned",
  // isEstimateReceived: "Estimate Received",
  // isEstimateApproved: "Estimate Approved",
  // isInvoiceReceived: "Invoice Received",
  poGenerated: "PO Generation",
  poAutoAccept: "PO Auto Accept",
  showEndReminder: "After Event Reminder",
};

export const coordinatorEmailNotificationOptionalPreference = {
  isEventDetailsUpdated: "Event Details Updates",
  isWorkHoursUpdated: "Work Hours Updates",
  isPositionChanges: "Position Changes",
  isSessionChanges: "Session Changes",
  isNewNoteAdded: "New Note Added",
  poApproval: "PO Approval",
  gustoApprovalRemainders: "Gusto Approval Reminder",
  issueReported: "Reported Issues",
  passwordUpdated: "Password Update",
};

export const freelanceEcEmailNotificationNecessaryPreference = {
  isNewEventAdded: "New Event Assigned",
  // isEstimateReceived: "Estimate Received",
  // isEstimateApproved: "Estimate Approved",
  // isInvoiceReceived: "Invoice Received",
  poGenerated: "PO Generation",
  poAutoAccept: "PO Auto Accept",
  showEndReminder: "After Event Reminder",
};

export const freelanceEcEmailNotificationOptionalPreference = {
  isEventDetailsUpdated: "Event Details Updates",
  isWorkHoursUpdated: "Work Hours Updates",
  isPositionChanges: "Position Changes",
  isSessionChanges: "Session Changes",
  isNewNoteAdded: "New Note Added",
  poApproval: "PO Approval",
  gustoApprovalRemainders: "Gusto Approval Reminder",
  issueReported: "Reported Issues",
  passwordUpdated: "Password Update",
};

export const adminEmailNotificationNecessaryPreference = {
  isEventSubmission: "New Event Added",
  isEstimateReceived: "Estimate Generation",
  isEstimateApproved: "Estimate Approved",
  isInvoiceReceived: "Invoice Received",
  poGenerated: "PO Generation",
  poAutoAccept: "PO Auto Accept",
  reimbursements: "Reimbursements",
  showEndReminder: "After Event Reminder",
};

export const adminEmailNotificationOptionalPreference = {
  isEventDetailsUpdated: "Event Details Updates",
  isWorkHoursUpdated: "Work Hours Updates",
  isPositionChanges: "Position Changes",
  isSessionChanges: "Session Changes",
  isNewNoteAdded: "New Note Added",
  poApproval: "PO Approval",
  gustoApprovalRemainders: "Gusto Approval Reminder",
  issueReported: "Reported Issues",
  passwordUpdated: "Password Update",
  contractorSignUp: "Contractor Sign-Up",
  triggerEmailOnPOPaid: "Contractor PO Paid",
};